import { useFormikSendErrors } from '../hooks';

export default function AnalyticsSendFormErrors({ name }: { name: string }) {
  useFormikSendErrors(name);
  return null;
}
